import { c as _c } from "react/compiler-runtime";
import type { BudgetStatement, MetricWithoutBudget, SortOptionValue } from '@/modules/finances/types';
import { BudgetEmptyState } from '../budget-empty-state';
import { BudgetStatementListMobile } from '../budget-statement-mobile/budget-statement-list-mobile';
import { BudgetStatementTable } from '../budget-statement-table';
import { useBudgetStatementData } from './use-budget-statement-data';
export interface BudgetStatementsItemProps {
  budgetStatements: BudgetStatement[];
  budgetMetric: MetricWithoutBudget;
  sortOption?: SortOptionValue;
  asSectionContent?: boolean;
}
function BudgetStatementsItem(t0) {
  const $ = _c(8);
  const {
    budgetStatements,
    budgetMetric,
    sortOption,
    asSectionContent: t1
  } = t0;
  const asSectionContent = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== budgetStatements || $[1] !== sortOption) {
    t2 = {
      budgetStatements,
      sortOption
    };
    $[0] = budgetStatements;
    $[1] = sortOption;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    processedBudgetStatements
  } = useBudgetStatementData(t2);
  if (processedBudgetStatements.length === 0) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <BudgetEmptyState />;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] !== asSectionContent || $[5] !== budgetMetric || $[6] !== processedBudgetStatements) {
    t3 = <><BudgetStatementTable budgetStatements={processedBudgetStatements} className="hidden lg:block" budgetMetric={budgetMetric} asSectionContent={asSectionContent} /><BudgetStatementListMobile budgetStatements={processedBudgetStatements} selectedMetric={budgetMetric} className="lg:hidden" asSectionContent={asSectionContent} /></>;
    $[4] = asSectionContent;
    $[5] = budgetMetric;
    $[6] = processedBudgetStatements;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export { BudgetStatementsItem };